export default [
  {
    name: 'login', // 登录
    url: '/login'
  },
  {
    name: 'logout', // 登出
    url: '/logout'
  },
  {
    name: 'getAuthorList', // 获取作者列表
    url: '/user/list'
  },
  {
    name: 'orderList', // 获取订单管理列表
    url: '/order/list'
  },
  {
    name: 'addAuthor', // 添加作者
    url: '/user/add'
  },
  {
    name: 'delAuthor', // 删除作者
    url: '/user/del'
  },
  {
    name: 'getQiToken', // 获取七牛token
    url: '/user/getToken'
  },
  {
    name: 'updateAuthor', // 修改作者
    url: '/user/chg'
  },
  {
    name: 'getImgPath', // 根据key获取图片地址
    url: '/user/getUrl'
  },
  {
    name: 'getAuthorOrder', // 获取作者订单
    url: '/order/list'
  },
  {
    name: 'articleList', // 文章列表
    url: '/post/list'
  },
  {
    name: 'addArticle', // 新增文章
    url: '/post/save'
  },
  {
    name: 'upArticle', // 修改文章
    url: '/post/chg'
  },
  {
    name: 'delArticle', // 删除文章
    url: '/post/del'
  },
  {
    name: 'queryUser', // 普通用户查询
    url: '/member/list'
  },
  {
    name: 'chgMyself', // 修改个人信息
    url: '/user/chgInfo'
  },
  {
    name: 'getMyself', // 获取个人信息
    url: '/user/info'
  },
  {
    name: 'addPicture', // 添加头像
    url: '/head/add'
  },
  {
    name: 'getPictureList', // 获取头像
    url: '/head/list'
  },
  {
    name: 'removePicture',
    url: '/head/del'
  },
  {
    name: 'getBannerList', // 获取首页banner列表
    url: '/banner/list'
  },
  {
    name: 'addBanner', // 新增banner
    url: '/banner/add'
  },
  {
    name: 'delBanner', // 删除banner
    url: '/banner/del'
  },
  {
    name: 'memberList', // 会员列表
    url: '/vipUserMange/list'
  },
  {
    name: 'memberEdit', // 会员编辑
    url: '/vipUserMange/update'
  }
]
